"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createUuid = void 0;
/**
 * Generiert eine eindeutige ID. Kann verwendet werden, um z.B. `order_id` zu setzen, obwohl keine existiert.
 *
 * @category Utils
 */
const createUuid = () => {
    var _a;
    const uuid = (_a = window.crypto) === null || _a === void 0 ? void 0 : _a.randomUUID();
    if (uuid !== null && uuid.length > 0) {
        return uuid;
    }
    else {
        return URL.createObjectURL(new Blob([])).slice(-36);
    }
};
exports.createUuid = createUuid;
